<template>
  <div id="input-code">
      <h1 :class="$i18n.locale">{{ $t('sign.input_code') }}</h1>
      <p :class="$i18n.locale">{{ $t('sign.code_sended') }}<span>{{ (isPhoneRegist ? '+' + this.area : '') + ' ' + (this.form ? this.form.phone : '-') }}</span></p>
      <div class="vcode" id='vertifycode'>
        <input v-model="code" type="tel" maxlength='6' ref='code' class='code' id='code' @focus="focus = true" @blur="focus = false" :disabled="disabled" />
        <div class="labels">
            <label v-for="(item, index) in length" :key="index" v-text="arrCode[index]" :class='{ active: focus === true && index === currentIndex }' class='label' for="code" />
        </div>
      </div>
      <div class="send-btn" :disabled="ifSended" :class="ifSended ? 'sended' : 'active'" @click="sendCode">{{ ifSended ? `${countDown}s ${ $t('sign.re_get') }` : $t('sign.resend') }}</div>
      <div class="alert" v-show="alertShow">
            <span>{{message}}</span>
      </div>
      <jgz-loading :loading-show='showLoading'></jgz-loading>
  </div>
</template>

<script>
import JgzLoading from '@/components/JgzLoading.vue'
export default {
    name: 'InputCode',
    data() {
        return {
            ifSended: false,
            countDownFunc: null,
            countDown: 60,
            length: 6,
            // currentIndex: 0,
            code: '',
            focus: false,
            // arrCode: [],
            disabled: false,
            alertShow: false,
            message: '验证码有误',
            showLoading: false,
            form: {},
            area: '852',
            isPhoneRegist: false,
            language: '',
        }
    },
    components: {
        JgzLoading,
    },
    computed: {
        arrCode() {
            return this.code.split('')
        },
        currentIndex() {
            return this.code.length
        }
    },
    watch: {
        code(newVal, oldVal) {
            let self = this
            this.code = newVal.replace(/[^\d]/g, '')
            if(newVal.length >= 6) {
                // this.disabled = true
                this.$refs.code.blur()
                setTimeout(() => {
                    console.log('提交'+this.code)
                    this.goSuccess()
                }, 500)
            }
        }
    },
    mounted() {
        this.form = this.$route.params.form
        this.area = this.$route.params.area
        this.isPhoneRegist = this.$route.params.tag
        let locale = localStorage.getItem('lang')
        switch (locale) {
            case 'zh':
                this.language = 'CHINESE'
                break;
            case 'zh-h':
                this.language = 'CHINESETRAD'
                break;
            case 'en':
                this.language = 'ENGLISH'
                break;
            default:
                break;
        }
        if(!this.form) {
            this.$router.go(-1)
        }
        this.$refs.code.focus()
        this.sendCode()
    },
    methods: {
        sendCode() {
            if(this.ifSended) {
                return
            }
            this.ifSended = true
            const params = this.form ? (this.isPhoneRegist ? { mobile: this.area + this.form.phone, useFor: 'register', scope: 'JGZ', 'language': this.language } : { email: this.form.phone, useFor: 'register', scope: 'JGZ', 'language': this.language }) : ''
            this.$MyAxios.post(`/api/accounts/verificationCode`, 
            params, 
            true,
            response => {
                if(response.code === 1) {
                    this.countDownFunc = setInterval(() => {
                        if (this.countDown > 1) {
                            this.countDown--
                        } else {
                            this.ifSended = false
                            this.countDown = 60
                            clearInterval(this.countDownFunc)
                            this.countDownFunc = null
                        }
                    }, 1000)
                }
            }, error => {
                this.alertShow = true
                this.message = error
                setTimeout(() => {
                    this.alertShow = false
                }, 2000);
                this.countDownFunc = setInterval(() => {
                    if (this.countDown > 1) {
                        this.countDown--
                    } else {
                        this.ifSended = false
                        this.countDown = 60
                        clearInterval(this.countDownFunc)
                        this.countDownFunc = null
                    }
                }, 1000)
            })
            
            
        },
        register() {
            this.showLoading = false;
            let params = {
                password: this.form.password,
                code: this.code,
                inviteCode: this.form.inviteCode,
                scope: 'JGZ',
                roles: ''
            }
            if(this.isPhoneRegist) {
                params['mobile'] = this.area + this.form.phone
            } else {
                params['email'] = this.form.phone
            }
            this.$MyAxios.post(`/register`, 
            params, 
            false,
            response => {
                if(response.code === 1) {
                    this.showLoading = false;
                    if(this.$route.meta.from === 'fxh') {
                        this.$router.push('/sign-in-success-fromfxh')
                    }
                    this.$router.push('/sign-in-success')
                }
            }, error => {
                this.alertShow = true
                this.message = error
                setTimeout(() => {
                    this.alertShow = false
                }, 2000);
            })
        },
        goSuccess() {
            this.register()
        }
    }
}
</script>

<style lang='less'>
#input-code {
    background: #ffffff;
    height: 100vh;
    padding: 60px 55px 0 55px;
    h1 {
        height: 70px;
        line-height: 70px;
        font-size: 50px;
        font-weight: bold;
        margin-bottom: 10px;
        color: #33333a;
        &.en {
            font-size: 42px;
        }
    }
    p {
        color: #9598A6;
        font-size: 30px;
        font-weight: 400;
        margin-bottom: 50px;
        span {
            color: #FFA41F;
        }
        &.en {
            font-size: 28px;
        }
    }
    .send-btn {
        height: 42px;
        width: 210px;
        margin: 0 auto;
        font-size: 30px;
        &.sended {
            color: #9598A6;
        }
        &.active {
            color: #FFA41F;
        }
    }
    @keyframes animate {
        100% {
            opacity: 0;
        }
    }
    .container {
        padding: 5%;
    }
    .vcode {
        position: relative;
        width: 100%;
        overflow: hidden;
        margin-bottom: 50px;
    }
    .code {
        width: 100%;
        padding: 0;
        height: 60px;
        font-size: 35px;
        overflow: hidden;
        border: none;
        outline: none;
        opacity: 0;
        margin-left: -175vw; // ios上透明度为0时依然有光标
        -webkit-tap-highlight-color: transparent;
    }
    .labels {
        display: flex;
        display: -webkit-flex;
        width: 100%;
        height: 60px;
        justify-content: space-between;
        -webkit-justify-content: space-between;
        margin-top: -60px;
        -webkit-tap-highlight-color: transparent;// 解决ios点击灰色阴影的问题
    }
    .label {
        height: 60px;
        width: 12%;
        border-bottom: solid 2px #CCCED9;
        float: left;
        color: #33333A;
        font-size: 36px;
        line-height: 36px;
        text-align: center;
        padding-bottom: 10px;
        &.active:after { // 伪类实现光标效果
            content: ' ';
            display: inline-block;
            height: 100%;
            width: 2px;
            background: #313131;
            animation: .8s animate infinite;
        }
    }
    .alert {
        position: fixed;
        z-index: 3;
        top: 40%;
        left: 50%;
        height: 60px;
        width: auto;
        padding: 0 30px;
        transform: translateX(-50%);
        border-radius: 8px;
        background: rgba(0, 0, 0, .9);
        color: #ffffff;
        line-height: 60px;
    }
}
</style>